<script>
import List from './components/List.vue'
import Operation from './components/Operation.vue'

const prefixCls = 'ivu-transfer'

export default {
  name: 'Transfer',
  render (h) {
    return h(
      'div',
      {
        class: this.classes
      },
      [
        h(
          List,
          {
            ref: 'left',
            props: {
              prefixCls: this.prefixCls + '-list',
              data: this.leftData,
              renderFormat: this.renderFormat,
              checkedKeys: this.leftCheckedKeys,
              validKeysCount: this.leftValidKeysCount,
              listStyle: this.listStyle,
              title: this.localeTitles[0],
              filterable: this.filterable,
              filterPlaceholder: this.filterPlaceholder[0],
              filterMethod: this.filterMethod,
              notFoundText: this.localeNotFoundText,
              showCheckBox: this.showCheckBox
            },
            on: {
              'on-checked-keys-change': this.handleLeftCheckedKeysChange
            }
          }
        ),

        h(Operation, {
          props: {
            prefixCls: this.prefixCls,
            operations: this.operations,
            leftActive: this.leftValidKeysCount > 0,
            rightActive: this.rightValidKeysCount > 0
          }
        }),

        h(
          List,
          {
            ref: 'right',
            props: {
              prefixCls: this.prefixCls + '-list',
              data: this.rightData,
              renderFormat: this.renderFormat,
              checkedKeys: this.rightCheckedKeys,
              validKeysCount: this.rightValidKeysCount,
              listStyle: this.listStyle,
              title: this.localeTitles[1],
              filterable: this.filterable,
              filterPlaceholder: this.filterPlaceholder[1],
              filterMethod: this.filterMethod,
              notFoundText: this.localeNotFoundText,
              showCheckBox: this.showCheckBox
            },
            on: {
              'on-checked-keys-change': this.handleRightCheckedKeysChange
            }
          }
        )
      ]
    )
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    renderFormat: {
      type: Function,
      default (item) {
        return item.label || item.key
      }
    },
    targetKeys: {
      type: Array,
      default () {
        return []
      }
    },
    selectedKeys: {
      type: Array,
      default () {
        return []
      }
    },
    listStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    titles: {
      type: Array
    },
    operations: {
      type: Array,
      default () {
        return [ '<', '>' ]
      }
    },
    filterable: {
      type: Boolean,
      default: false
    },
    filterPlaceholder: {
      type: Array,
      default () {
        return [ '请输入关键字...', '请输入关键字...' ]
      }
    },
    filterMethod: {
      type: Function,
      default (data, query) {
        const type = 'label' in data ? 'label' : 'key'
        return data[type].indexOf(query) > -1
      }
    },
    notFoundText: {
      type: String
    },
    showCheckBox: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      prefixCls: prefixCls,
      leftData: [],
      rightData: [],
      leftCheckedKeys: [],
      rightCheckedKeys: []
    }
  },
  computed: {
    classes () {
      return [`${prefixCls}`]
    },
    leftValidKeysCount () {
      return this.getValidKeys('left').length
    },
    rightValidKeysCount () {
      return this.getValidKeys('right').length
    },
    localeNotFoundText () {
      if (this.notFoundText === undefined) {
        return '没有记录'
      } else {
        return this.notFoundText
      }
    },
    localeTitles () {
      if (this.titles === undefined) {
        return [ 'source', 'target' ]
      } else {
        return this.titles
      }
    }
  },
  methods: {
    refresh () {
      this.splitData(false)
      this.leftCheckedKeys = []
      this.rightCheckedKeys = []
    },
    getValidKeys (direction) {
      return this[`${direction}Data`]
        .filter(
          data =>
            !data.disabled &&
            this[`${direction}CheckedKeys`].indexOf(data.key) > -1
        )
        .map(data => data.key)
    },
    splitData (init = false) {
      this.leftData = [...this.data]
      this.rightData = []
      if (this.targetKeys.length > 0) {
        this.targetKeys.forEach(targetKey => {
          const filteredData = this.leftData.filter((data, index) => {
            if (data.key === targetKey) {
              this.leftData.splice(index, 1)
              return true
            }
            return false
          })
          if (filteredData && filteredData.length > 0) this.rightData.push(filteredData[0])
        })
      }
      if (init) {
        this.splitSelectedKey()
      }
    },
    splitSelectedKey () {
      const selectedKeys = this.selectedKeys
      if (selectedKeys.length > 0) {
        this.leftCheckedKeys = this.leftData
          .filter(data => selectedKeys.indexOf(data.key) > -1)
          .map(data => data.key)
        this.rightCheckedKeys = this.rightData
          .filter(data => selectedKeys.indexOf(data.key) > -1)
          .map(data => data.key)
      }
    },
    moveTo (direction) {
      const targetKeys = this.targetKeys
      const opposite = direction === 'left' ? 'right' : 'left'
      const moveKeys = this.getValidKeys(opposite)
      const newTargetKeys =
        direction === 'right'
          ? moveKeys.concat(targetKeys)
          : targetKeys.filter(
            targetKey =>
              !moveKeys.some(checkedKey => targetKey === checkedKey)
          )

      this.$refs[opposite].toggleSelectAll(false)
      this.$emit('on-change', newTargetKeys, direction, moveKeys)
    },
    handleLeftCheckedKeysChange (keys) {
      this.leftCheckedKeys = keys
    },
    handleRightCheckedKeysChange (keys) {
      this.rightCheckedKeys = keys
    },
    handleCheckedKeys () {
      const sourceSelectedKeys = this.getValidKeys('left')
      const targetSelectedKeys = this.getValidKeys('right')
      this.$emit('on-selected-change', sourceSelectedKeys, targetSelectedKeys)
    }
  },
  watch: {
    targetKeys () {
      this.splitData(false)
    },
    data () {
      this.splitData(false)
    }
  },
  mounted () {
    this.splitData(true)
  }
}
</script>
<style>

.ivu-transfer-list-body-with-search {
  padding-top: 42px;
}

.ivu-cell-group {
  overflow: scroll;
  height: 100%;
}

</style>
